import { lazy } from "react";

// After a deploy, a tab that was already open still asks for the old
// page chunks, which the server no longer has (404 -> blank page).
// When a chunk fails to load, reload once so the tab picks up the new
// build. The timestamp stops a reload loop if the chunk is really missing.
const KEY = "chunk-reload-at";
const WAIT_MS = 30 * 1000;

const isChunkError = (err) =>
  /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(
    `${err?.name || ""} ${err?.message || ""}`
  );

export default function lazyWithReload(factory) {
  return lazy(() =>
    factory().catch((err) => {
      if (!isChunkError(err)) throw err;
      let last = 0;
      try {
        last = Number(sessionStorage.getItem(KEY)) || 0;
      } catch (e) {}
      if (Date.now() - last < WAIT_MS) throw err;
      try {
        sessionStorage.setItem(KEY, String(Date.now()));
      } catch (e) {}
      window.location.reload();
      return new Promise(() => {});
    })
  );
}
